import { a as __rest, _ as __assign } from './_tslib-ff3a08af.js';
import { createMuiTheme } from '@material-ui/core';

var createAppTheme = function (constants, options) {
    var _a = options !== null && options !== void 0 ? options : {},
        palette = _a.palette,
        typography = _a.typography,
        restOfOptions = __rest(_a, ["palette", "typography"]);
    return createMuiTheme(__assign({ spacing: 4, typography: __assign({ fontSize: 14, fontFamily: 'Ubuntu Sans, sans-serif' }, typography), palette: __assign({ primary: {
                main: constants.colors.primaryColor
            } }, palette) }, restOfOptions));
};

export { createAppTheme as c };
